import { render, staticRenderFns } from "./Dotkit-v1.vue?vue&type=template&id=e597dc8a&scoped=true&"
import script from "./Dotkit-v1.vue?vue&type=script&lang=js&"
export * from "./Dotkit-v1.vue?vue&type=script&lang=js&"
import style0 from "./Dotkit-v1.vue?vue&type=style&index=0&id=e597dc8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e597dc8a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VResponsive,VRow})
